import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Handles the state for the SMS Opt In Nudge Modal *
 */
export const MARKETING_SMS_OPT_IN_DISMISSED =
  'MARKETING_SMS_OPT_IN_DISMISSED' as IUserMilestone.RetailerMilestone;
